<template>
    <div>
        <b-button v-b-toggle.collapse-maintenance class="w-100 mb-1" variant="outline-secondary"
                  ref="toggleMaintenance">
            <i class="fa-solid fa-power-off"></i>
            {{ $t('action-items.schedule-maintenance') }}
        </b-button>
        <b-collapse id="collapse-maintenance" class="mt-2 mb-2 w-100">
            <b-list-group-item>
                <b-form>
                    <b-form-group
                        id="input-group-maintenance-text"
                        :label="$t('comment')"
                        label-for="textarea-maintenance">
                        <b-form-textarea v-model="v$.MaintenanceForm.comment.$model"
                                         :class="{ 'is-invalid': v$.MaintenanceForm.$error }"
                                         id="textarea-maintenance"
                                         name="textarea-maintenance"
                                         placeholder="$t('comment').."
                                         rows="3"
                                         max-rows="6"
                        ></b-form-textarea>
                        <div class="invalid-feedback" v-if="v$.MaintenanceForm.comment.required">Field is required
                        </div>
                    </b-form-group>
                    <div class="row">
                        <div class="col-md-6">
                            <label>{{ $t('start') }}</label>
                            <b-form-input :class="{ 'is-invalid': v$.MaintenanceForm.from.$error }" v-model="v$.MaintenanceForm.from.$model" type="datetime-local"></b-form-input>
                            <div class="invalid-feedback" v-if="v$.MaintenanceForm.from.required">{{ $t('Field is required') }}</div>
                        </div>
                        <div class="col-md-6">
                            <label>{{ $t('end') }}</label>
                            <b-form-input :class="{ 'is-invalid': v$.MaintenanceForm.to.$error }" v-model="v$.MaintenanceForm.to.$model" type="datetime-local"></b-form-input>
                            <div class="invalid-feedback" v-if="v$.MaintenanceForm.to.required">{{ $t('Field is required') }}</div>
                        </div>
                    </div>
                    <b-button variant="success" @click="setMaintenance"
                              class="w-100 mt-1 mb-1">
                        {{ $t('forms.send-command') }}
                    </b-button>
                </b-form>
            </b-list-group-item>
        </b-collapse>
    </div>
</template>

<script>
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import {useToast} from "vue-toastification";

export default {
    name: "Maintenance",
    props: [
        'uuids'
    ],
    data(){
        return {
            MaintenanceForm: {
                comment: 'in progress',
                from: '',
                to: '',
            },
        }
    },
    setup: () => ({ v$: useVuelidate() }),
    validations: {
        MaintenanceForm: {
            comment: {
                required,
            },
            from: {required},
            to: {required}
        }
    },
    methods: {
        getDates(){
            axios.post('/downtimes/get_dates.json')
                .then(response => {
                    if(response.status === 200){
                        let datetime = response.data.datetime[0];
                        this.MaintenanceForm.from = datetime.start_time;
                        this.MaintenanceForm.to = datetime.end_time;
                    }
                });
        },
        async setMaintenance(){
            this.v$.MaintenanceForm.$touch();
            const validated = await this.v$.MaintenanceForm.$validate();
            if(!validated){
                return;
            }
            if(this.uuids.length > 0){
                let externalCommands = [];
                for(var i = 0; i < this.uuids.length; i++){
                    externalCommands.push({
                        command: 'submitServiceDowntime',
                        hostUuid: this.uuids[i].hostUuid,
                        serviceUuid: this.uuids[i].serviceUuid,
                        start: this.MaintenanceForm.from,
                        end: this.MaintenanceForm.to,
                        author: this.$store.state.user,
                        comment: this.MaintenanceForm.comment,
                    });
                }
                this.$emit('masscommand', externalCommands);
            }else{
                useToast().error('no services selected', {
                    timeout: 2000
                });
            }
        },
    },
    mounted(){
        this.getDates();
    },
}
</script>

<style scoped>

</style>
